import { ActionTypes, ReduxAction } from './types';
import {
  AbliefernachweisService,
  AuftragexportService,
  AuftragService,
  SendungsstatusService,
  StatusService,
} from '../../api';
import { DatumTypEnum } from '../../models/DatumTypEnum';
import { Dispatch } from 'redux';
import { setNotification } from '../../utils/notificationUtils';
import httpSearchQueue from '../../config/HttpSearchQueue';

export const getAuftraege =
  (
    value?: string,
    page?: number,
    searchLimit?: number,
    dateFrom?: string,
    dateTo?: string,
    dateCategory?: DatumTypEnum,
    mandant?: number,
    offeneAuftraege?: boolean
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    httpSearchQueue
      .add(new AuftragService().searchAuftraege, [
        value,
        page,
        searchLimit,
        dateFrom,
        dateTo,
        dateCategory,
        mandant,
        offeneAuftraege,
      ])
      .then(response => {
        dispatch({
          type: ActionTypes.SET_TOTALSEARCHRESULTS,
          payload: response.headers['total-search-results'],
        });

        dispatch({
          type: ActionTypes.GET_AUFTRAEGE,
          payload: response.data,
        });
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const zurUebertragungMarkieren =
  (iDList: number[], reLoad: () => void) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().zurUebertragungMarkieren(iDList).then(response => {
      dispatch({
        type: ActionTypes.UPDATE_ZUR_UEBERTRAGUNG_MARKIEREN,
        payload: response.data,
      });

      // notification success
      reLoad();
    });
  };

export const zurUebertragungDeMarkieren =
  (iDList: number[]) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().resetStati(iDList).then(response => {
      const numberOfResetetAuIDS = response.data;

      dispatch({
        type: ActionTypes.UPDATE_RESET_STATI,
        payload: numberOfResetetAuIDS,
      });
      setNotification(
        'Es wurden ' +
          numberOfResetetAuIDS +
          ' Aufträge aus der Übertragung an DISPONENTplus entfernt',
        []
      );
    });
  };

export const updateTyp =
  (typ: number, iDList: number[]) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().updateTyp(typ, iDList).then(response => {
      dispatch({
        type: ActionTypes.UPDATE_TYP,
        payload: response.data,
      });
      // notification success
    });
  };

export const zurTypUebertragungMarkieren =
  (typ: number, iDList: number[]) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    await new AuftragService().updateTyp(typ, iDList);

    setNotification(
      'Ihre Preisanfrage wurde versendet und wird nun berechnet. Dies kann mehrere Minuten dauern.',
      []
    );
    const response = await new AuftragService().zurTypUebertragungMarkieren(
      iDList
    );
    dispatch({
      type: ActionTypes.UPDATE_ZUR_TYPUEBERTRAGUNG_MARKIEREN,
      payload: response.data,
    });
  };

export const deleteAuftrag =
  (ids: number[]) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService().deleteAuftraege(ids).then(response => {
      dispatch({
        type: ActionTypes.DELETE_AUFTRAG,
        payload: response.data,
      });
    });
  };

export const setAuftragResearchField =
  (value: any, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAGRESEARCH_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };

export const setAuftraegeSortBy =
  (attributeName: string, sortingCount: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAEGE_SORT_BY,
      payload: {
        attributeName: attributeName,
        sortingCount: sortingCount,
      },
    });
  };

export const getDefaultstatuskette =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new SendungsstatusService().getDefaultstatuskette().then((result: any) => {
      dispatch({
        type: ActionTypes.GET_DEFAULTSTATUSKETTE,
        payload: result.data,
      });
    });
  };

export const getAllStati = () => async (dispatch: Dispatch<ReduxAction>) => {
  new StatusService().getAllStati().then((result: any) => {
    dispatch({
      type: ActionTypes.GET_ALL_STATI,
      payload: result.data,
    });
  });
};

export const set_From_and_To_Date =
  (dateFrom: string, dateTo: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_FROM_AND_TO_DATE,
      payload: { dateFrom: dateFrom, dateTo: dateTo },
    });
  };

export const viewPDF =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AbliefernachweisService()
      .getAbliefernachweis(id, {
        responseType: 'blob',
      })
      .then((response: any) => {
        const file = new Blob([response.data], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);
        const pdfWindow = window.open();
        if (pdfWindow != null) pdfWindow.location.href = fileUrl;
      });
  };

export const getAuftraegeCSV =
  (dateFrom?: string, dateTo?: string, mandant?: number) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });

    let ergebnisliste = '';

    const countResponse =
      await new AuftragexportService().getCountZeitraumAuftragExportCsv(
        dateFrom,
        dateTo,
        mandant
      );

    const countAuftraege: any = countResponse.data;
    const maxAuftraegeProRequest = countAuftraege > 1000 ? 100 : 10;

    const fullIterations = Math.trunc(countAuftraege / maxAuftraegeProRequest);

    const remainder = countAuftraege % maxAuftraegeProRequest;
    const iterations = remainder > 0 ? 1 + fullIterations : fullIterations;
    let min = 0;
    let max = maxAuftraegeProRequest;

    dispatch({
      type: ActionTypes.COUNT_AUFTRAEGE,
      payload: countAuftraege,
    });

    for (let i = 1; i < iterations + 1; i++) {
      dispatch({
        type: ActionTypes.CSVEXPORT,
        payload: min,
      });

      const csvString =
        await new AuftragexportService().getZeitraumAuftragExportCsv(
          dateFrom,
          dateTo,
          mandant,
          min,
          maxAuftraegeProRequest
        );

      min = max;
      max = min + maxAuftraegeProRequest;

      ergebnisliste = ergebnisliste + csvString.data;
    }
    dispatch({
      type: ActionTypes.CSVEXPORT,
      payload: countAuftraege,
    });
    if (ergebnisliste) {
      const blob = new Blob([ergebnisliste], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', url);
      a.setAttribute(
        'download',
        'Auftraege_' + dateFrom + '_' + dateTo + '.csv'
      );

      dispatch({
        type: ActionTypes.CSVEXPORT,
        payload: 'Schreibe Datei ',
      });
      dispatch({
        type: ActionTypes.COUNT_AUFTRAEGE,
        payload: '',
      });
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setNotification(
        ' Aufträge wurden erfolgreich in Datei ' +
          'Auftraege_' +
          dateFrom +
          '_' +
          dateTo +
          '.csv exportiert',
        []
      );
      dispatch({
        type: ActionTypes.CSVEXPORT,
        payload: 'Fertig mit dem Export der Aufträge',
      });
    } else {
      dispatch({
        type: ActionTypes.COUNT_AUFTRAEGE,
        payload: 'Für den angegebenen Zeitraum gibt es keine Aufträge',
      });
      dispatch({
        type: ActionTypes.CSVEXPORT,
        payload: '',
      });
    }

    dispatch({
      type: ActionTypes.LOADING,
      payload: false,
    });
  };

export const getBerechnteile =
  (auftragId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragService()
      .getBerechnteileByAuftragId(auftragId)
      .then(response => {
        dispatch({
          type: ActionTypes.GET_BERECHNTEILE,
          payload: response.data,
        });
      });
  };
